import { useState } from "react";

type Props = {
  src: string;
  alt: string;
  className?: string;
  imgClassName?: string;
  eager?: boolean;
  label?: string;
  testId?: string;
};

/**
 * Renders an official photo when the file exists at `src`; otherwise a
 * designed placeholder that names the exact file to drop in.
 * Dropping the real file into /public/assets/photos/ makes it appear
 * automatically — no component changes needed.
 */
export function PhotoFrame({
  src,
  alt,
  className = "",
  imgClassName = "",
  eager = false,
  label = "OFFICIAL PHOTO PENDING",
  testId,
}: Props) {
  const [failed, setFailed] = useState(false);
  return (
    <div
      data-testid={testId}
      className={`relative overflow-hidden border border-white/10 bg-eve-surface ${className}`}
    >
      {failed ? (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 bg-[radial-gradient(circle_at_50%_35%,rgba(123,44,255,0.14),transparent_65%)]">
          <span className="font-display text-6xl uppercase leading-none tracking-[0.2em] text-white/[0.07]">
            EVE
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-eve-silver/80">
            {label}
          </span>
          <span className="font-mono text-[10px] text-white/25">{src}</span>
        </div>
      ) : (
        <img
          src={src}
          alt={alt}
          loading={eager ? "eager" : "lazy"}
          decoding="async"
          onError={() => setFailed(true)}
          className={`h-full w-full object-cover ${imgClassName}`}
        />
      )}
    </div>
  );
}
